import { render, staticRenderFns } from "./BarEchart2.vue?vue&type=template&id=5dd93426&scoped=true&"
import script from "./BarEchart2.vue?vue&type=script&lang=js&"
export * from "./BarEchart2.vue?vue&type=script&lang=js&"
import style0 from "./BarEchart2.vue?vue&type=style&index=0&id=5dd93426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd93426",
  null
  
)

export default component.exports